module.exports = __webpack_public_path__ + "static/img/icon_help.d3ba5183.png";